import clsx from "clsx";
import { PropsWithChildren, useCallback, useEffect, useState } from "react";
import pkg from "../../../package.json";
import { LayoutConfig } from "../../../types/util";
import LayoutContext, { LayoutContextState } from "../../context/LayoutContext";
import Header from "../Header/Header";
import styles from "./Layout.module.scss";

export type LayoutProps = PropsWithChildren<{
  a?: boolean;
  config?: LayoutConfig;
}>;

function Layout({ a, children, config }: LayoutProps) {
  const [layoutConfig, setLayoutConfig] = useState(config);

  useEffect(() => {
    setLayoutConfig(config);
  }, [config]);

  const updateLayoutConfig: LayoutContextState["update"] = useCallback(
    (key, value) => {
      setLayoutConfig((prev) => ({
        ...prev,
        [key]: value,
      }));
    },
    []
  );

  return (
    <LayoutContext.Provider
      value={{ config: layoutConfig, update: updateLayoutConfig }}
    >
      <div className={clsx(styles.container, layoutConfig?.containerClassName)}>
        {!layoutConfig?.hideHeader && (
          <Header
            ignoreSession={layoutConfig?.ignoreSession}
            hideNavigation={layoutConfig?.hideNavigation}
          />
        )}
        <main
          className={clsx(
            styles.main,
            a && styles.admin,
            layoutConfig?.mainClassName
          )}
        >
          {children}
        </main>
        {layoutConfig?.hideFooter ? null : (
          <footer className={styles.footer}>
            ©&nbsp;{new Date().getFullYear()} Green Aureus GmbH | Alle Rechte
            vorbehalten
            {(process.env.NODE_ENV !== "production" || a) && (
              <span className={styles.version}>v{pkg.version}</span>
            )}
          </footer>
        )}
      </div>
    </LayoutContext.Provider>
  );
}

Layout.Messages = ["components.Layout", ...Header.Messages];

export default Layout;
